export default __webpack_public_path__ + "static/media/dots.6e357005.svg";